import About from "./About";
import Help from "./Help";
import OurStory from "./OurStory";
import ShareTheLove from "./ShareTheLove";
import Feedback from "./Feedback";
import JoinUs from "../../routes/screens/Auth/JoinUs";
import Unsubscribe from "./Unsubscribe";
import WhyLocalE from "./WhyLocalE";

export default {
  About,
  Help,
  OurStory,
  ShareTheLove,
  Feedback,
  JoinUs,
  Unsubscribe,
  WhyLocalE
};
